import React from 'react';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  return (
    <div className="w-full relative">
      <div
        className="relative min-h-[525px] sm:min-h-[615px] bg-cover bg-top bg-no-repeat flex items-center justify-center"
        style={{ backgroundImage: "url('/assets/aboutus-hero.webp')" }}
      >
        {/* Content */}
        <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto">
          <h2 className="max-w-[296px] sm:max-w-fit mx-auto text-white text-[24px] sm:text-[25.8px] leading-[35px] sm:leading-[38px] font-normal libre-baskerville mb-6">
            {t('about.hero.title')}
          </h2>
          <p className="text-white text-[12px] sm:text-[14px] leading-[20px] sm:leading-[24px] font-medium">
            {t('about.hero.subtitle')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Hero;
